import React from 'react'

function AspirasiOff() {
    return (
        <div className="container-lapor">
            <button className='opsi-aspirasi'>
                <h2>Aspirasi</h2>
            </button>
        </div>
    )
}

export default AspirasiOff



// WEBPACK FOOTER //
// ./src/pages/Components/Opsi-Lapor/Aspirasi.js